import * as THREE from "three";
import { STLExporter } from "three/examples/jsm/exporters/STLExporter.js";

export function downloadBinaryStl(
  geometry: THREE.BufferGeometry,
  filename: string,
): void {
  const exporter = new STLExporter();
  const material = new THREE.MeshBasicMaterial();
  const mesh = new THREE.Mesh(geometry, material);
  mesh.updateMatrixWorld(true);

  const result = exporter.parse(mesh, { binary: true });
  material.dispose();

  if (!(result instanceof DataView)) {
    throw new Error("The STL exporter did not return binary data.");
  }

  const copiedBytes = new Uint8Array(
    result.buffer,
    result.byteOffset,
    result.byteLength,
  ).slice();

  const blob = new Blob([copiedBytes.buffer], {
    type: "model/stl",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename.endsWith(".stl") ? filename : `${filename}.stl`;
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.setTimeout(() => URL.revokeObjectURL(link.href), 1_000);
}
